import { omitBy } from 'lodash'
import { removedFeaturePrefixes, removedFeatureKeys, isRemovedFeature } from '@gimmatek/shared/store-scope'

/**
 * 店家方案功能套用 GIMMATEK Store 範圍：移除模組的功能一律關閉（CNCY-10766）
 *
 * checkFeature 以「最後一個符合的 key」為準，所以先刪掉方案裡屬於移除模組的 key，
 * 再把禁用的 key 加在最後，蓋過 `admin.*` 這類較早出現的萬用 key
 *
 * @param {Record<string, boolean>} features 後端回傳的 shopPlanFeature
 * @returns {Record<string, boolean>}
 */
export const applyGimmatekStoreScope = (features = {}) => {
  const scoped = omitBy(features, (_, key) => isRemovedFeature(key))
  removedFeaturePrefixes.forEach((prefix) => {
    scoped[`${prefix}.*`] = false
  })
  removedFeatureKeys.forEach((key) => {
    scoped[key] = false
  })
  return scoped
}
